import { Resources } from '@shared/localizations/Resources';
import { InstrumentTypes, InstrumentTypesColor, formatInstrumentType, getInstrumentTypeShortName, isFuturesInsteadSpot } from './InstrumentTypes';
import { PriceFormatter } from './PriceFormatter';
import { ProductType } from './ProductType';
import { HistoryType } from '../History/HistoryType';
import { MathUtils } from '../MathUtils';
import { TradingMode } from './TradingMode';
import { StringUtils } from '../StringUtils';
class _InstrumentUtils {
    constructor() {
        this.MAX_PRECISION_ON_SERVER = 8; // #46163  - уточнил у Хоменко, база данных на сервере не поддерживает большую точность цены , для js взял с клиента
        this.SEPARATOR = ':';
    }
    OpenSpread(SpreadPlan, instrument) {
        let spreadItem = null;
        if (!isNullOrUndefined(SpreadPlan) && SpreadPlan.IsNotEmptyPlan(instrument)) {
            spreadItem = SpreadPlan.GetItem(instrument);
        }
        if (spreadItem !== null) {
            if (instrument.HistoryType === HistoryType.QUOTE_LEVEL1) {
                return spreadItem.CalcBid(instrument.BidOpen, instrument.AskOpen, instrument);
            }
            else if (instrument.HistoryType === HistoryType.QUOTE_ASK) {
                return spreadItem.CalcAsk(instrument.BidOpen, instrument.AskOpen, instrument);
            }
        }
        return instrument.Open;
    }
    HighSpread(SpreadPlan, instrument) {
        let spreadItem = null;
        if (!isNullOrUndefined(SpreadPlan) && SpreadPlan.IsNotEmptyPlan(instrument)) {
            spreadItem = SpreadPlan.GetItem(instrument);
        }
        if (spreadItem !== null) {
            if (instrument.HistoryType === HistoryType.QUOTE_LEVEL1) {
                return spreadItem.CalcBid(instrument.BidHigh, instrument.AskHigh, instrument);
            }
            else if (instrument.HistoryType === HistoryType.QUOTE_ASK) {
                return spreadItem.CalcAsk(instrument.BidHigh, instrument.AskHigh, instrument);
            }
        }
        return instrument.High;
    }
    LowSpread(SpreadPlan, instrument) {
        let spreadItem = null;
        if (!isNullOrUndefined(SpreadPlan) && SpreadPlan.IsNotEmptyPlan(instrument)) {
            spreadItem = SpreadPlan.GetItem(instrument);
        }
        if (spreadItem !== null) {
            if (instrument.HistoryType === HistoryType.QUOTE_LEVEL1) {
                return spreadItem.CalcBid(instrument.BidLow, instrument.AskLow, instrument);
            }
            else if (instrument.HistoryType === HistoryType.QUOTE_ASK) {
                return spreadItem.CalcAsk(instrument.BidLow, instrument.AskLow, instrument);
            }
        }
        return instrument.Low;
    }
    PrevCloseSpread(SpreadPlan, instrument) {
        let spreadItem = null;
        if (!isNullOrUndefined(SpreadPlan) && SpreadPlan.IsNotEmptyPlan(instrument)) {
            spreadItem = SpreadPlan.GetItem(instrument);
        }
        if (spreadItem !== null) {
            if (instrument.HistoryType === HistoryType.QUOTE_LEVEL1) {
                return spreadItem.CalcBid(instrument.BidPrevClose, instrument.AskPrevClose, instrument);
            }
            else if (instrument.HistoryType === HistoryType.QUOTE_ASK) {
                return spreadItem.CalcAsk(instrument.BidPrevClose, instrument.AskPrevClose, instrument);
            }
        }
        return instrument.Close;
    }
    Get_Ticks_From_RealOffsetPrice(instrument, absoluteOffset, optionsVariousPipsSize = -1) {
        if (instrument == null) {
            return absoluteOffset;
        }
        if (instrument.PointSize === 0) {
            return 0.0;
        }
        if (optionsVariousPipsSize === -1 || optionsVariousPipsSize === 0) {
            optionsVariousPipsSize = instrument.PointSize;
        }
        return Number((absoluteOffset / optionsVariousPipsSize).toFixed(0)); // именно пипс тут! так правильно только для форекс
    }
    GetFullName(symbol, route) {
        if (!symbol)
            return '';
        return !route || symbol.indexOf(InstrumentUtils.SEPARATOR) !== -1
            ? symbol
            : symbol + InstrumentUtils.SEPARATOR + route;
    }
    ParseRouteName(symbol) {
        if (!symbol) {
            return '';
        }
        const index = symbol.lastIndexOf(InstrumentUtils.SEPARATOR);
        return index >= 0 ? symbol.substr(index + InstrumentUtils.SEPARATOR.length) : '';
    }
    RemoveRouteName(symbol) {
        if (!symbol) {
            return null;
        }
        const index = symbol.lastIndexOf(InstrumentUtils.SEPARATOR);
        return index >= 0 ? symbol.substr(0, index) : symbol;
    }
    IsFullName(name) {
        return name !== null && name.lastIndexOf(InstrumentUtils.SEPARATOR) > -1;
    }
    GetFullNameUnsafe(symbol, route) {
        return symbol + InstrumentUtils.SEPARATOR + route;
    }
    // TODO. Ugly.
    DivideFullName(symbol) {
        let name = null;
        let route = null;
        const index = symbol.lastIndexOf(InstrumentUtils.SEPARATOR);
        if (index === -1) {
            name = symbol;
            route = '';
        }
        else {
            name = symbol.substr(0, index);
            route = symbol.substr(index + 1);
        }
        return { name, route };
    }
    getAllowedProductTypeDict(instrument) {
        if (!instrument) {
            return [];
        }
        return instrument.RiskSettings.RiskPlanSettings.availableProductTypes;
    }
    GetLocalizedProductType(instrument, productType) {
        if (!instrument)
            return '';
        if (productType == ProductType.Delivery &&
            (instrument.isFutureOrOption() ||
                (instrument.InstrType && instrument.InstrType === InstrumentTypes.CFD_FUTURES))) {
            return Resources.getResource('ProductType.CarryForward');
        }
        return Resources.getResource('ProductType.' + ProductType[productType]);
    }
    getInstrumentTypeStringLocalized(type, cfd = undefined) {
        if (type === -1) {
            return Resources.getResource('panel.TerceraSymbolLookupDropDownForm.All');
        }
        return formatInstrumentType(type, cfd);
    }
    getPutCallOptionsTypeStringLocalized(instrument) {
        // special Option type string for WatchList's Group By #114165
        if (!instrument) {
            return null;
        }
        return instrument.isOptionSymbol
            ? Resources.getResource(instrument.PutCall
                ? 'panel.TerceraSymbolLookupDropDownForm.Options.Put'
                : 'panel.TerceraSymbolLookupDropDownForm.Options.Call')
            : instrument.getTypeString();
    }
    UseFuturesInsteadSpotShortName() {
        return isFuturesInsteadSpot()
            ? getInstrumentTypeShortName(InstrumentTypes.FUTURES)
            : getInstrumentTypeShortName(InstrumentTypes.SPOT);
    }
    UseFuturesInsteadSpotColor() {
        return isFuturesInsteadSpot()
            ? InstrumentTypesColor[InstrumentTypes.FUTURES]
            : InstrumentTypesColor[InstrumentTypes.SPOT];
    }
    ConvertPointsToTicks(instrument, offsetInPoints) {
        if (!(instrument === null || instrument === void 0 ? void 0 : instrument.PointSize)) {
            return null;
        }
        return offsetInPoints / instrument.PointSize;
    }
    GetTradingStatus(instrument) {
        if (!instrument) {
            return StringUtils.NOT_AVAILABLE;
        }
        const route = instrument ? instrument.DataCache.Routes.getRouteByName(instrument.getRoute()) : null;
        if (route == null || !route.IsTradable) {
            return (Resources.getResource('InstrumentDetailsPanel.Closed') +
                ' ' +
                Resources.getResource('InstrumentDetailsPanel.(Indicative symbol)'));
        }
        else if (instrument.TradingMode === TradingMode.FullyOpen) {
            return (Resources.getResource('InstrumentDetailsPanel.Open') +
                (instrument.InstrType === InstrumentTypes.INDICIES
                    ? ' ' + Resources.getResource('InstrumentDetailsPanel.(Indicative symbol)')
                    : ''));
        }
        else if (instrument.TradingMode === TradingMode.TradingHalt) {
            return Resources.getResource('InstrumentDetailsPanel.TradingHalt');
        }
        else if (instrument.TradingMode === TradingMode.LiquidationOnly) {
            return Resources.getResource('InstrumentDetailsPanel.LiquidationOnly');
        }
        else if (instrument.TradingMode === TradingMode.CAMaintenance) {
            return Resources.getResource('InstrumentDetailsPanel.CAMaintenance');
        }
        else {
            return Resources.getResource('InstrumentDetailsPanel.Closed');
        }
    }
    formatAmountValue(value, instrument, account, productType = ProductType.General) {
        if (instrument == null) {
            return PriceFormatter.formatPrice(value, 2);
        }
        const prec = instrument.getLotStepPrecision(productType, account);
        if (value >= 1 && MathUtils.trunc(value) === value) {
            const lotStep = instrument.getLotStep(productType, account);
            if (MathUtils.trunc(lotStep) === lotStep) {
                // N0 format.
                return PriceFormatter.formatPrice(value, 0);
            }
            else {
                return PriceFormatter.formatPrice(value, prec);
            }
        }
        else {
            return PriceFormatter.formatPrice(value, prec);
        }
    }
    getFormatPrice(instrument, price, NAString) {
        if (isNaN(price)) {
            // || price === -1)   // #87569
            return NAString;
        }
        return instrument ? instrument.formatPrice(price) : price.toFixed(4);
    }
    getFormatVolume(instrument, volume, showLots = false, NAString = null, productType = ProductType.General, account = null) {
        NAString = NAString !== null && NAString !== void 0 ? NAString : StringUtils.NOT_AVAILABLE;
        if (isNaN(volume) || instrument == null) {
            return NAString;
        }
        return instrument.DataCache.formatVolume(instrument, instrument.getDoubleVolume(volume, showLots), showLots, productType, account);
    }
    ParseSearchPattern(pattern) {
        if (!isValidString(pattern)) {
            return pattern;
        }
        if (pattern.startsWith('[')) {
            pattern = pattern.substring(1);
        }
        if (pattern.endsWith(']')) {
            pattern = pattern.substring(0, pattern.length - 1);
        }
        return pattern;
    }
}
export const InstrumentUtils = new _InstrumentUtils();
